import { request } from '@/common/utils/request'
// const testHost = 'http://10.179.18.142:8497'
export function addVisit(params) {
  return request.post('crm.bdapp.visit.visit.addVisit', {
    data: params,
  })
}

export function initVisit(params) {
  return request
    .get({
      url: 'crm.bdapp.visit.init',
      params,
    })
    .then(res => res.data)
}
export function getVisitDetail(params) {
  return request
    .get({
      url: 'crm.bdapp.visit.getDetail',
      params,
    })
    .then(res => res.data)
}

export function getShopVisitList(params) {
  return request
    .get({
      url: 'crm.bdapp.visit.getList',
      params,
    })
    .then(res => res.data)
}

export function postBusinessInfo(params) {
  return request.post('crm.bdapp.visit.updateBizoppExt', {
    data: params,
  })
}

export function addVisitPlan(params) {
  return request.post('crm.bdapp.visit.addPlan', {
    data: params,
  })
}
export function updateVisitPlan(params) {
  return request.post('crm.bdapp.visit.updatePlan', {
    data: params,
  })
}
export function getVisitList(params) {
  return request
    .get({
      url: 'crm.visit.visit.list',
      params,
    })
    .then(res => res.data)
    .catch(() => {
      return false
    })
}

export function closeVisitPlan(params) {
  return request.post('crm.bdapp.visit.closePlan', {
    data: params,
  })
}

// 获取所在国家 订单均价
export function getPriceRange(params) {
  return request
    .get({
      url: 'crm.shop.store.getAvgPriceRange',
      params,
    })
    .then(res => res.data)
    .catch(() => {
      return false
    })
}

// 获取拜访对象初始化数据
export function getVisitObjectInit(params) {
  return request
    .get({
      url: 'crm.bdapp.visit.visitObjectInit',
      params,
    })
    .then(res => res.data)
    .catch(() => {
      return false
    })
}

// 获取拜访对象初始化数据
export function saveVisitObject(params) {
  return request
    .post({
      url: 'crm.bdapp.visit.saveVisitObject',
      params,
    })
    .then(res => res.data)
    .catch(() => {
      return false
    })
}

export function visitBrandDetail(params) {
  return request
    .get({
      url: 'feidian.brand.visitDetail',
      params,
    })
    .then(res => res.data)
}
